import type { ComponentRegistry } from '@vibesites/runtime';
import {
  Header,
  Hero,
  PropertyOverview,
  SpecialOffers,
  CTASection,
  FloorplansList,
  AmenitiesList,
  Gallery,
  NeighborhoodMap,
  VirtualTourEmbed,
  ContactUs,
  ScheduleATour,
  Fees,
  PetPolicy,
  ResidentAccess,
  ApplyNow,
  AccessibilityStatement,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  ThankYouContent,
  ScheduleATourCallout,
  FloorPlansHero,
  AmenitiesHero,
  VirtualTourHero,
  GalleryHero,
  NeighborhoodHero,
  ContactHero,
  ResidentAccessHero,
  ScheduleATourHero,
  ReviewsHero,
  PetPolicyHero,
  InteractiveMapHero,
  PrivacyPolicyHero,
  SitemapHero,
  AccessibilityHero,
  ApplyNowHero,
  ThankYouHero,
  FAQHero,
  FAQList,
  PageBlurb,
  Reviews,
  ReviewsCallout,
  SocialFollow,
  NeighborhoodCallout,
  SpecialOfferBanner,
  FutureResidentsClub,
  Footer,
  Navigation,
} from './components';

export const registry: ComponentRegistry = {
  Header,
  Hero,
  FloorPlansHero,
  AmenitiesHero,
  VirtualTourHero,
  GalleryHero,
  NeighborhoodHero,
  ContactHero,
  ResidentAccessHero,
  ScheduleATourHero,
  ReviewsHero,
  PetPolicyHero,
  InteractiveMapHero,
  PrivacyPolicyHero,
  SitemapHero,
  AccessibilityHero,
  ApplyNowHero,
  ThankYouHero,
  FAQHero,
  FAQList,
  PageBlurb,
  PropertyOverview,
  SpecialOffers,
  SpecialOfferBanner,
  CTASection,
  FloorplansList,
  AmenitiesList,
  Gallery,
  NeighborhoodMap,
  VirtualTourEmbed,
  ContactUs,
  ScheduleATour,
  Fees,
  PetPolicy,
  ResidentAccess,
  ApplyNow,
  AccessibilityStatement,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  ThankYouContent,
  ScheduleATourCallout,
  Reviews,
  ReviewsCallout,
  SocialFollow,
  NeighborhoodCallout,
  FutureResidentsClub,
  Footer,
  Navigation,
};

export default registry;
